import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonCardComponent } from './person-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { LogoutModule } from '../logout';

@NgModule({
    declarations: [PersonCardComponent],
    exports: [PersonCardComponent],
    imports: [CommonModule, RouterModule, LogoutModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class PersonCardModule {}
